<template>
  <div>
    <AppDownloadBanner mode="applicant" action-link="/resume" @action-click="handleDetailClick" />
    <div class="footer-wrapper">
      <footer class="main-footer applicant-footer">
        <div class="sec-wrap footer-container">
          <!-- Left Logo/Brand Column -->
          <div class="footer-brand-section">
            <router-link :to="{ name: 'homeIndex' }" class="footer-logo-link">
              <img src="@/assets/images/common/logo_footer.svg" width="60" height="91" alt="BIB Job" />
            </router-link>
            <p class="footer-brand-desc">
              <span class="en bold">BIB JOB</span> သည် မြန်မာနိုင်ငံရှိ နောက်ဆုံးရ အလုပ်အကိုင်များကို တစ်နေရာတည်းတွင်
              အလွယ်တကူရှာဖွေနိုင်ပြီး စိတ်ချရသော အလုပ်ရှင်များနှင့်ချိတ်ဆက်ပေးရန် ရည်ရွယ်ပါသည်။
            </p>
          </div>

          <!-- Right Main Navigation & Contacts Section -->
          <div class="footer-links-contacts-section">
            <!-- Top Nav Links -->
            <nav class="footer-nav-row">
              <router-link :to="{ name: 'homeIndex' }">ပင်မစာမျက်နှာ</router-link>
              <router-link :to="{ name: 'jobCategory' }">အလုပ်အမျိုးအစားများ</router-link>
              <router-link :to="{ name: 'jobRequest' }">အလုပ်ရှာပိုစ့်များ</router-link>
              <a href="/resume" @click.prevent="goResumeRegister()">အလုပ်လျှောက်လွှာပြုလုပ်ရန်</a>
              <router-link :to="{ name: 'contactUsNew' }">ဆက်သွယ်ရန်ဖောင်</router-link>
            </nav>

            <!-- Divider Line -->
            <div class="footer-divider"></div>

            <!-- Middle Contact Row -->
            <div class="footer-contact-row">
              <div class="footer-contact-col en">
                <app-icon name="phone" size="20" class="contact-icon-svg" />
                <a href="tel:+959797420117" class="contact-link">09 787 420 117</a>
              </div>
              <div class="footer-contact-col en">
                <app-icon name="mail" size="20" class="contact-icon-svg" />
                <a href="mailto:bib.job.mm@gmail.com" class="contact-link">bib.job.mm@gmail.com</a>
              </div>
              <div class="footer-contact-col address-col">
                <app-icon name="location" size="20" class="contact-icon-svg" />
                <a href="https://maps.app.goo.gl/XxEfMJdLLExhXoXEA" target="_blank" rel="noopener noreferrer"
                  class="contact-link">
                  အမှတ်(၈၈/၉၀)၊ ၄လွှာ၊ ၅၁လမ်း၊ အလယ်ဘလောက်၊ ပုဇွန်တောင်မြို့နယ်၊ ရန်ကုန်မြို့။
                </a>
              </div>
            </div>

            <!-- Bottom Social Row -->
            <div class="footer-social-row">
              <a href="https://www.facebook.com/BIBMyanmarJobs" class="social-link" target="_blank" rel="noopener">
                <img src="@/assets/images/common/ico_fb.svg" alt="Facebook" />
              </a>
              <a href="https://www.tiktok.com/@bibjobcompany" class="social-link" target="_blank" rel="noopener">
                <img src="@/assets/images/common/ico_tiktok.svg" alt="TikTok" />
              </a>
              <a href="https://t.me/bibmyanmarjobsagency" class="social-link" target="_blank" rel="noopener">
                <img src="@/assets/images/common/ico_telegram.svg" alt="Telegram" />
              </a>
            </div>
          </div>
        </div>

        <!-- Bottom White Bar for Privacy Policy & Copyright -->
        <div class="footer-bottom-bar">
          <div class="sec-wrap bottom-bar-container">
            <router-link :to="{ name: 'policy' }" class="privacy-link">Privacy Policy</router-link>
            <span class="copyright-text">
              Copyright © BIB Co., Ltd. All rights reserved.
            </span>
          </div>
        </div>

        <!-- Page Top Button -->
        <div class="page-top">
          <a href="#top" id="toTop" class="top-lnk" aria-label="Back to top">
            <img src="@/assets/images/common/img_pagetop01.png" alt="" width="54" height="54" aria-hidden="true"
              loading="lazy" />
          </a>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import $ from 'jquery';

export default {
  name: 'Footer',
  computed: {
    ...mapGetters({
      applicantId: 'applicantId',
      resumeCountNo: 'resumeCountNo',
    }),
  },
  methods: {
    handleDetailClick() {
      if (!this.applicantId) {
        this.$router.push('/applicant/login', () => {});
        return;
      }

      const count = Number(this.resumeCountNo || 0);

      if (count >= 3) {
        this.$notification.error(
          'အလုပ်လျှောက်လွှာအများဆုံး ၃ ခုသာ ပြုလုပ်ခွင့်ပြုသည်။',
          { timer: 3, position: 'bottomCenter' }
        );
        return;
      }

      this.$router.push('/resume', () => {});
    },

    goResumeRegister() {
      if (!this.applicantId) {
        this.$router.push('/applicant/login', () => {});
        return;
      }

      if (Number(this.resumeCountNo || 0) >= 3) {
        this.$notification.error(
          'အလုပ်လျှောက်လွှာအများဆုံး ၃ ခုသာ ပြုလုပ်ခွင့်ပြုသည်။',
          { timer: 3, position: 'bottomCenter' }
        );
        return;
      }
      this.$router.push('/resume', () => {});
    },
  },
  mounted() {
    const topBtn = $('.page-top');
    topBtn.hide();

    const handleScroll = () => {
      if ($(window).scrollTop() > 100) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    };

    $(window).on('scroll', handleScroll);
    handleScroll();

    $("#toTop").on('click', function (e) {
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      }, 1000);
    });

    this._handleScroll = handleScroll;
  },
  beforeDestroy() {
    if (this._handleScroll) {
      $(window).off('scroll', this._handleScroll);
    }
    $("#toTop").off('click');
  }
};
</script>
